if (!customElements.get('footer-app-switcher')) {
  customElements.define('footer-app-switcher', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      const tablist = this.querySelector('[role="tablist"]');
      if (!tablist) return;
      const tabs = [...tablist.querySelectorAll('[role="tab"]')];
      const panels = tabs.map(tab => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
      if (panels.some(panel => !panel)) return;
      const select = (index, focus = false) => {
        this.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[position].hidden = !selected;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => select(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        }, options);
        panels[index].addEventListener('shopify:block:select', () => select(index), options);
      });
      this.setAttribute('data-enhanced', '');
      select(Math.max(0, tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')));
      tablist.hidden = false;
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}

if (!customElements.get('footer-download')) {
  customElements.define('footer-download', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary) return;
      const placePanel = () => {
        if (!details.open) return;
        const panel = this.querySelector('.ik-footer__qr-panel');
        if (!panel) return;
        const bounds = summary.getBoundingClientRect();
        const requiredSpace = panel.getBoundingClientRect().height + 16;
        details.dataset.placement = bounds.top < requiredSpace && window.innerHeight - bounds.bottom > bounds.top ? 'below' : 'above';
      };
      const open = () => {
        this.closest('.ik-footer__apps')?.querySelectorAll('details[open]').forEach(item => {
          if (item !== details) item.open = false;
        });
        details.open = true;
        placePanel();
      };
      details.addEventListener('toggle', placePanel, options);
      window.addEventListener('resize', placePanel, options);
      window.addEventListener('scroll', placePanel, { ...options, passive: true });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') open();
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !this.contains(document.activeElement)) details.open = false;
      }, options);
      this.addEventListener('focusin', open, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) details.open = false;
      }, options);
      summary.addEventListener('pointerdown', () => {
        this.wasOpen = details.open;
      }, options);
      summary.addEventListener('click', event => {
        if (event.detail > 0) {
          event.preventDefault();
          if (this.wasOpen) details.open = false;
          else open();
        }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          summary.focus();
          details.open = false;
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) details.open = false;
      }, options);
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
